import { css, styled } from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Content = styled.div`
  padding: 2rem 0;

  @media (min-width: 991px) {
    .wrapper {
      max-width: 35rem;
      padding: 0 2rem;
    }
  }
`;

export const PreviewInformation = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding-bottom: 1.5rem;

  .wrapper {
    max-width: 39.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 1.5rem;

    .chakra-avatar {
      margin-top: -30px;
    }
  }

  @media (min-width: 991px) {
    max-width: 32.5rem;
    margin: 0 auto;
    border-radius: 0.674rem;
  }
`;

export const ContentForm = styled.div`
  padding: 2rem 0;
  background: ${({ theme }) => theme.colors.white};

  button {
    width: 100%;
  }

  .wrapper {
    max-width: 37.5rem;
  }

  @media (min-width: 991px) {
    max-width: 32.5rem;
    margin: 0 auto;
    border-radius: 0.674rem;
  }
`;

export const Title = styled.h2`
  font-size: 1.375rem;
  line-height: 1.563rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary.color};
  margin: 1rem 0 0;
`;

export const ConfirmedContainer = styled.div`
  width: 100%;
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  margin-top: 1rem;

  button {
    width: 100%;
  }
`;

export const InterestsContainer = styled.div`
  width: 100%;
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-top: 1.5rem;
`;

export const Subtitle = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.gray_blue.color};
  width: 100%;
`;

export const ContainerDays = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 1.5rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
`;

export const ButtonDay = styled.button<{ selected: boolean }>`
  width: 5.625rem !important;
  min-width: 5.625rem;
  height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 5px;
  font-size: 1.125rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.texts_light};
  box-shadow: 0 2px 0 0 rgba(103, 120, 115, 0.2);

  ${({ selected }) =>
    selected &&
    css`
      color: ${({ theme }) => theme.colors.white};
      background: ${({ theme }) => theme.colors.blue03.color};
    `}
`;

export const ContainerForm = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .custom-select-container {
    margin-bottom: 0;
  }
`;

export const Tag = styled.div`
  padding: 6px 10px;
  background: ${({ theme }) => theme.colors.blue03.color};
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};
  text-transform: uppercase;
`;
